<template>
    <p class="align-center hint footer">
        <router-link to="/changelog">
            Version {{version}}.
        </router-link>
    </p>
</template>

<script>
import changelog     from '@/../changelog.json';

export default {
    data() {
        var _ = this;

        return {
            version: Object.keys(changelog)[0]
        };
    }
};
</script>
